import { render, staticRenderFns } from "./modifier.vue?vue&type=template&id=06e60541&scoped=true"
import script from "./modifier.vue?vue&type=script&lang=js"
export * from "./modifier.vue?vue&type=script&lang=js"
import style0 from "./modifier.vue?vue&type=style&index=0&id=06e60541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e60541",
  null
  
)

export default component.exports